import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { links } from './data';
import { Link, useLocation } from 'react-router-dom';
import styles from './Navbar.module.css';

function useMouseGlow(ref) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const move = (e) => {
      const r = el.getBoundingClientRect();
      el.style.setProperty('--rx', `${((e.clientX - r.left) / r.width) * 100}%`);
      el.style.setProperty('--ry', `${((e.clientY - r.top) / r.height) * 100}%`);
    };
    el.addEventListener('mousemove', move);
    return () => el.removeEventListener('mousemove', move);
  }, [ref]);
}

function NavLink({ to, active, children }) {
  const ref = useRef(null);
  useMouseGlow(ref);

  const handleClick = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.classList.add(styles.rippling);
    setTimeout(() => el.classList.remove(styles.rippling), 350);
  }, []);

  return (
    <Link
      ref={ref}
      to={to}
      className={`${styles.link} ${active ? styles.active : ''}`}
      onClick={handleClick}
    >
      {children}
    </Link>
  );
}

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navRef = useRef(null);

  useEffect(() => { setMenuOpen(false); }, [location]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!menuOpen) return;
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    const timer = setTimeout(() => {
      document.addEventListener('pointerdown', handleClickOutside);
    }, 0);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('pointerdown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <>
      {menuOpen && ReactDOM.createPortal(
        <div
          className={styles.backdrop}
          onClick={() => setMenuOpen(false)}
          aria-hidden="true"
        />,
        document.body
      )}

      <nav
        ref={navRef}
        className={`${styles.navbar} ${scrolled ? styles.scrolled : ''}`}
      >
        <div className={styles.inner}>

          <Link to="/" className={styles.logo}>
            Ionut Stoleriu
          </Link>

          <ul className={styles.links}>
            {links.map(({ id, url, text }) => (
              <li key={id}>
                <NavLink to={url} active={location.pathname === url}>
                  {text}
                </NavLink>
              </li>
            ))}
          </ul>

          <button
            className={styles.toggle}
            onClick={() => setMenuOpen(o => !o)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
          >
            {menuOpen ? <FaTimes size={15} /> : <FaBars size={15} />}
          </button>

        </div>

        <div className={`${styles.drawer} ${menuOpen ? styles.drawerOpen : ''}`}>
          <div style={{ padding: '0 2rem' }}>
            {links.map(({ id, url, text }) => (
              <Link
                key={id}
                to={url}
                className={`${styles.drawerLink} ${location.pathname === url ? styles.active : ''}`}
              >
                {text}
              </Link>
            ))}
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;